(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fitzoraz-combo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fitzoraz-combo')) {
  customElements.define('fitzoraz-combo', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const decoder = document.createElement('textarea');
      this.strings = Object.fromEntries(
        Object.entries(JSON.parse(this.querySelector('[data-strings]').textContent)).map(([key, value]) => {
          decoder.innerHTML = value;
          return [key, decoder.value];
        })
      );
      this.cards = [...this.querySelectorAll('[data-item]')];
      this.button = this.querySelector('[data-add]');
      this.status = this.querySelector('[data-status]');
      this.root = (window.Shopify?.routes?.root || this.dataset.root || '/').replace(/\/?$/, '/');
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency});
      this.mode = 'add';
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-variant]') || this.busy) return;
        this.mode = 'add';
        this.transaction = null;
        this.message('');
        this.refresh();
      });
      this.button.addEventListener('click', () => this.submit());
      this.refresh();
    }
    selection() {
      return this.cards.map(card => {
        const option = card.querySelector('[data-variant]')?.selectedOptions[0];
        return {id: option?.value, price:Number(option?.dataset.price || 0), available:option?.dataset.available === 'true'};
      });
    }
    refresh() {
      const items = this.selection();
      this.valid = items.length === 4 && items.every(i => i.id && i.available) && new Set(this.cards.map(c=>c.dataset.productId)).size === 4;
      const subtotal = items.reduce((sum,i)=>sum+i.price,0);
      const savings = Math.round(subtotal * .2);
      this.querySelector('[data-subtotal]').textContent = this.money.format(subtotal/100);
      this.querySelector('[data-savings]').textContent = '−' + this.money.format(savings/100);
      this.querySelector('[data-savings-copy]').textContent = this.money.format(savings/100);
      this.querySelector('[data-total]').textContent = this.money.format((subtotal-savings)/100);
      this.cards.forEach((card,index)=>{
        const option=card.querySelector('[data-variant]')?.selectedOptions[0];
        const photo=card.querySelector('.fzc__image img');
        if(photo && option?.dataset.image && photo.getAttribute('src')!==option.dataset.image){photo.src=option.dataset.image;photo.removeAttribute('srcset');}
        const p = card.querySelector('strong[data-price]');
        if (p) p.textContent = this.money.format(items[index].price/100);
        card.classList.toggle('is-unavailable',!items[index].available);
        const included = card.querySelector('[data-included]');
        if (included) {
          included.replaceChildren();
          const mark=document.createElement('span');mark.textContent=items[index].available?'✓':'!';mark.setAttribute('aria-hidden','true');
          included.append(mark,document.createTextNode(' '+(items[index].available?this.strings.included:this.strings.soldOut)));
        }
      });
      this.button.disabled = this.busy || (this.mode==='add' && !this.valid);
      this.button.textContent = this.busy ? this.strings.loading : this.mode==='view' ? this.strings.view : this.mode==='discount' ? this.strings.retry : this.valid ? this.strings.cta : this.strings.unavailable;
    }
    message(text,error=false) {
      this.status.textContent=text;
      this.status.classList.toggle('fzc__error',error);
      this.querySelector('[data-cart-link]').hidden = !text;
    }
    async api(path,body) {
      const response = await fetch(this.root+path,{method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{})});
      const data=await response.json();
      if(!response.ok || data.status>=400) throw new Error(data.description || data.message || String(response.status));
      return data;
    }
    bundleCount(cart) {
      return this.transaction.items.filter(wanted => cart.items.some(item=>String(item.variant_id)===String(wanted.id) && item.properties?._fitzoraz_combo===this.transaction.id && item.quantity>=1)).length;
    }
    discountApplied(cart) {
      const named = value => String(value || '').toUpperCase()==='EXTRA20';
      if (cart.discount_codes?.some(code=>named(code.code) && code.applicable)) return true;
      const applications=[...(cart.cart_level_discount_applications || []),...(cart.items || []).flatMap(item=>(item.line_level_discount_allocations || []).map(a=>a.discount_application))];
      if (applications.some(a=>named(a.title) && (a.total_allocated_amount>0 || (a.value_type==='percentage' && Number(a.value)===20)))) return true;
      return (cart.items || []).some(item=>(item.discounts || []).some(d=>named(d.title) && Number(d.amount)>0));
    }
    sectionIds() {
      const drawer=document.querySelector('cart-drawer');
      try {
        const ids=drawer?.getSectionsToRender?.().map(s=>s.section || s.id).filter(Boolean);
        if(ids?.length) return [...new Set(ids)].slice(0,5);
      } catch (_) {}
      return ['cart-drawer','cart-icon-bubble'];
    }
    async showCart(cart,text,error=false) {
      const drawer=document.querySelector('cart-drawer');
      if(!drawer) {window.location.assign(this.root+'cart');return;}
      let sections=cart?.sections;
      const ids=this.sectionIds();
      if(!sections || ids.some(id=>typeof sections[id]!=='string')) {
        const url=new URL(window.location.href);url.searchParams.set('sections',ids.join(','));
        const response=await fetch(url,{credentials:'same-origin',cache:'no-store'});
        if(!response.ok) throw new Error('Cart sections unavailable');
        sections=await response.json();
      }
      if(ids.some(id=>typeof sections[id]!=='string')) {window.location.assign(this.root+'cart');return;}
      drawer.setActiveElement?.(this.button);
      if(typeof drawer.renderContents==='function') {
        drawer.renderContents({sections,id:cart?.items?.[0]?.variant_id});
      } else {
        const html=sections['cart-drawer'];
        const doc=new DOMParser().parseFromString(html,'text/html');
        const target=drawer.querySelector('#CartDrawer');
        const source=doc.querySelector('#CartDrawer');
        if(!target || !source) {window.location.assign(this.root+'cart');return;}
        target.innerHTML=source.innerHTML;
        const bubble=document.querySelector('#cart-icon-bubble');
        if(bubble && sections['cart-icon-bubble']) bubble.innerHTML=new DOMParser().parseFromString(sections['cart-icon-bubble'],'text/html').querySelector('.shopify-section')?.innerHTML || sections['cart-icon-bubble'];
        drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click',()=>drawer.close?.());
      }
      drawer.classList.toggle('is-empty',!cart?.item_count);
      drawer.querySelector('[data-fzc-message]')?.remove();
      if(text) {
        const node=document.createElement('p');node.dataset.fzcMessage='';node.setAttribute('role','status');
        node.className='fzc-drawer-message'+(error?' is-error':'');node.textContent=text;
        (drawer.querySelector('.drawer__inner') || drawer).prepend(node);
      }
      if(typeof drawer.open==='function') drawer.open(this.button);
      else window.location.assign(this.root+'cart');
      document.dispatchEvent(new CustomEvent('fitzoraz:combo-added',{detail:{cart}}));
    }
    async submit() {
      if(this.busy || window.fitzorazComboBusy) return;
      if(this.mode==='add' && !this.valid) {this.message(this.strings.notReady,true);return;}
      this.busy=true;window.fitzorazComboBusy=true;
      this.querySelectorAll('select').forEach(s=>s.disabled=true);
      this.refresh();this.message('');
      let cart;
      let changed=false;
      try {
        if(this.mode==='view') {cart=await this.api('cart.js');await this.showCart(cart);return;}
        if(this.mode==='add') {
          this.transaction={id:crypto.randomUUID?.() || ('fzc-'+Date.now()+'-'+Math.random().toString(36).slice(2)),items:this.selection()};
          changed=true;
          try {
            await this.api('cart/add.js',{items:this.transaction.items.map(i=>({id:i.id,quantity:1,properties:{_fitzoraz_combo:this.transaction.id}}))});
          } catch(error) {
            try {cart=await this.api('cart.js');} catch (_) {this.mode='view';throw new Error(this.strings.unknown);}
            const count=this.bundleCount(cart);
            if(count!==4) {
              this.mode=count?'view':'add';
              const text=count?this.strings.partial:this.strings.addError;
              this.message(text,true);await this.showCart(cart,text,true);return;
            }
          }
          this.mode='discount';
        }
        cart=await this.api('cart.js');
        if(!this.transaction || this.bundleCount(cart)!==4) {
          this.mode='view';this.message(this.strings.partial,true);await this.showCart(cart,this.strings.partial,true);return;
        }
        this.button.textContent=this.strings.pending;
        const prior=(cart.discount_codes || []).filter(d=>d.applicable).map(d=>d.code);
        (cart.cart_level_discount_applications || []).filter(d=>d.type==='discount_code').forEach(d=>prior.push(d.title));
        (cart.items || []).forEach(i=>(i.line_level_discount_allocations || []).filter(a=>a.discount_application?.type==='discount_code').forEach(a=>prior.push(a.discount_application.title)));
        const codes=[...new Set([...prior.map(c=>String(c).toUpperCase()),'EXTRA20'])];
        try {
          cart=await this.api('cart/update.js',{discount:codes.join(','),sections:this.sectionIds(),sections_url:window.location.pathname});
        } catch (_) {
          cart=await this.api('cart.js');
        }
        const applied=this.discountApplied(cart);
        this.mode=applied?'view':'discount';
        const text=applied?this.strings.success:this.strings.discountError;
        this.message(text,!applied);await this.showCart(cart,text,!applied);
      } catch(error) {
        if(changed && this.mode==='add') this.mode='view';
        this.message(this.mode==='discount'?this.strings.discountError:this.strings.unknown,true);
      } finally {
        this.busy=false;window.fitzorazComboBusy=false;
        this.querySelectorAll('select').forEach(s=>s.disabled=false);
        this.refresh();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
